import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

export default function Sustainability() {
  return (
    <section id="sustainability" className="relative flex flex-col md:flex-row overflow-hidden">
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="flex-1 bg-white pt-28 md:pt-32 pb-24 md:pb-32 flex items-center md:justify-end order-first md:order-none"
      >
        <div className="container max-w-xl mx-auto md:mx-0 md:pr-8 lg:pr-10">
          <h2 className="text-sm font-semibold text-accent uppercase tracking-wider mb-3">Sustainability</h2>
          <h3 className="text-3xl md:text-4xl font-bold font-heading text-primary tracking-tight leading-tight mb-4">
            Responsible operations, lasting impact
          </h3>
          <p className="text-slate-600 leading-relaxed mb-8">
            Lynas is committed to environmental stewardship, renewable energy adoption and transparent governance across our mining and processing operations.
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 text-accent font-semibold hover:text-accent/80 transition-colors"
          >
            Learn more
            <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </motion.div>
      <motion.div
        initial={{ opacity: 0, x: 20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className="flex-1 min-h-[320px] md:min-h-[480px] bg-cover bg-center bg-no-repeat order-last"
        style={{ backgroundImage: 'url(/assets/sustainability-wind-farm.png)' }}
      />
    </section>
  )
}
